import { Locale } from '@ps-smart-cp/ppfw-client';

const orderNameConfig = {
  asc: new Map([
    [Locale.ja, '昇順'],
    [Locale.en, 'ASC'],
  ]),

  desc: new Map([
    [Locale.ja, '降順'],
    [Locale.en, 'DESC'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { orderNameConfig };
